"use strict";
/*
**  Promise Composer Object class
*/

var _typeof2 = require("/builds/equisense/frontend/webapp-chercheurs-v2/node_modules/@babel/runtime/helpers/typeof");

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var PCO =
/*#__PURE__*/
function () {
  function PCO() {
    _classCallCheck(this, PCO);
  }

  _createClass(PCO, null, [{
    key: "result",

    /*
    **  Common functions
    */
    // Local assertion handling function
    value: function result(value, assertion) {
      return assertion ? Promise.resolve(value) : Promise.reject(PCO.ASSERTION_FALSE);
    } // Muted assertion handling function (doesn't reject, only resolve)

  }, {
    key: "mutedResult",
    value: function mutedResult(value, assertion) {
      return assertion ? Promise.resolve(value) : Promise.resolve(PCO.ASSERTION_FALSE);
    } // Local method to return assertion result instead of promise

  }, {
    key: "pure",
    value: function pure(x, assertion) {
      return assertion;
    } // Allow custom assertions to be created

  }, {
    key: "assert",
    value: function assert(x, assertFunc) {
      var func = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PCO.result;
      return func(x, assertFunc(x));
    }
    /*
    **  Functions to allow more complex conditional composition using Arrays
    */
    // General multiple assertion helper

  }, {
    key: "multiAssert",
    value: function multiAssert(x, assertions, verif) {
      return Promise.all(assertions.map(function (a) {
        return a(x, PCO.mutedResult);
      })).then(function (raw) {
        var values = raw.filter(function (v) {
          return v !== PCO.ASSERTION_FALSE;
        }); // Throw a .catch() clause if the verification function is false

        if (verif(raw, values)) {
          return x;
        } else {
          throw PCO.ASSERTION_FALSE;
        }
      });
    } // Continue if all conditions are true

  }, {
    key: "all",
    value: function all(x, assertions) {
      return PCO.multiAssert(x, assertions, function (r, v) {
        return v.length === r.length;
      });
    } // Continue if one condition at least is true

  }, {
    key: "any",
    value: function any(x, assertions) {
      return PCO.multiAssert(x, assertions, function (r, v) {
        return v.length > 0 || r.length === 0;
      });
    } // Traverse array of values to confirm assertions to them

  }, {
    key: "traverse",
    value: function traverse(values, assertion) {
      return Promise.all(values.map(function (x) {
        return assertion(x, PCO.mutedResult);
      })).then(function (raw) {
        var values = raw.filter(function (v) {
          return v !== PCO.ASSERTION_FALSE;
        }); // Throw a .catch() clause if not all values are validated

        if (values.length === raw.length) {
          return values;
        } else {
          throw PCO.ASSERTION_FALSE;
        }
      });
    }
    /*
    **  Assertion functions, exposed and usable
    **  by the end-user
    */
    // Assert element is not undefined

  }, {
    key: "isset",
    value: function isset(x) {
      var func = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PCO.result;
      return func(x, typeof x !== "undefined");
    } // Assert element is neither undefined or null

  }, {
    key: "exists",
    value: function exists(x) {
      var func = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PCO.result;
      return func(x, PCO.isset(x, PCO.pure) && x !== null);
    } // Assert element is a non-empty string

  }, {
    key: "fullString",
    value: function fullString(x) {
      var func = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PCO.result;
      return func(x, typeof x === "string" && x.trim() !== "");
    } // Assert element is valid non-array object

  }, {
    key: "isObject",
    value: function isObject(x) {
      var func = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PCO.result;
      return func(x, _typeof(x) === "object" && !Array.isArray(x));
    } // Assert element is valid array

  }, {
    key: "isArray",
    value: function isArray(x) {
      var func = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PCO.result;
      return func(x, Array.isArray(x));
    } // Assert element is a valid number

  }, {
    key: "isNumber",
    value: function isNumber(x) {
      var func = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PCO.result;
      return func(x, typeof x === "number");
    } // Assert element is an Integer

  }, {
    key: "isInteger",
    value: function isInteger(x) {
      var func = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PCO.result;
      return func(x, Number.isInteger(x));
    }
  }, {
    key: "ASSERTION_FALSE",

    /*
    **  Class constants
    */
    // Regular constants
    get: function get() {
      return "PCO_ASSERTION_FALSE";
    }
  }]);

  return PCO;
}();

module.exports = PCO;